import Styled from 'styled-components'

export const ContainerDate = Styled.div`

:root & {
    --nav-prev-bg: var(--primary-color);
    --nav-next-bg: var(--primary-color);
    --nav-prev-icon: #ffffff;
    --nav-next-icon: #ffffff;
    --nav-disabled-bg: #ffffff;
    --nav-disabled-icon: #d7d7dd;
}

.rdrCalendarWrapper {
    min-height: 380px;
    height: 380px;
}

.rdrMonth {
    min-height: 350px;
    height: 350px;
}

.rdrMonths {
    min-height: 350px;
}

.rdrDays {
    min-height: 280px;
    height: 280px;
}

.rdrSelected, .rdrInRange{
    background: var(--primary-color);
    
}

.rdrDateDisplayWrapper {
    background-color: transparent !important;
    
}

.rdrDateDisplay {
    margin: 0;
}

.rdrDateDisplay {
    gap: 0;
}

.rdrDayPassive > .rdrDayNumber * {
 // color: transparent !important;
  visibility: hidden;
}

.rdrMonthName {
    text-align: center;
    font-weight: 400;
    color: #000000;
    text-transform: capitalize;
}


// .rdrDayWeekend:not(.rdrDayDisabled) .rdrDayNumber span {
//     color: #333333 !important;
// }


.rdrMonthAndYearPickers {
    text-transform: capitalize;
}

.rdrWeekDay {
    text-transform: capitalize;
}

.rdrSelected, .rdrInRange, .rdrStartEdge, .rdrEndEdge {
    top: 0px;
    bottom: 0px;
}

.rdrStartEdge:last-child  {
    background-color: #D9D9D9;
}

.rdrDayToday .rdrDayNumber span:after {
    background: var(--primary-color);
}

.rdrDayDisabled, .rdrDayPassive {
    background-color: #FFF;
}

.rdrDay {
    line-height: 3.4em;
    height: 3.4em;
    margin: 1px 0;
}

.rdrInRange {
    background-color: ${props => !props.noDate ? '#D9D9D9' : '#FFF' };
}

.rdrEndEdge {
    border-top-right-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
    background-color: var(--primary-color);
}

.rdrDayEndOfMonth .rdrInRange {
    margin-right: -2px;
}

.rdrDayEndOfMonth .rdrStartEdge, .rdrDayEndOfWeek .rdrInRange, .rdrDayEndOfWeek .rdrStartEdge {
    border-radius: 0px!important;
}

.rdrDayStartOfMonth .rdrInRange {
    border-top-left-radius:  50%;
    border-bottom-left-radius:  50%;
    margin-left: -2px;
}

.rdrDayStartOfMonth .rdrEndEdge, .rdrDayStartOfWeek .rdrInRange, .rdrDayStartOfWeek .rdrEndEdge {
    border-radius: 0px!important;
}

button.rdrDay:not(.rdrDayPassive):has(span):has(.rdrStartEdge) {
    background-color: ${props => !props.noDate ? '#D9D9D9' : '#FFF' };    
}

button.rdrDay:not(.rdrDayPassive):has(span):has(.rdrEndEdge) {
    background-color: #D9D9D9;    
}

.rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span {
   // color: #8f8f8fd9;
}

.rdrDay .rdrInRange ~ .rdrDayNumber span {
    color: #8f8f8fd9;
}

.rdrDay:not(.rdrDayDisabled) .rdrInRange ~ .rdrDayNumber span {
    color: #333 !important;
}


.rdrStartEdge ~ .rdrDayNumber span {
    color: #FFF;
}

.rdrEndEdge ~ .rdrDayNumber span {
    color: #FFF;
}

.rdrDay:is(.rdrDayPassive) .rdrEndEdge, .rdrDay:is(.rdrDayPassive) .rdrStartEdge {

}

.rdrDayPassive .rdrEndEdge,.rdrDayPassive .rdrStartEdge, .rdrDayPassive .rdrInRange {
 //   display: block;
}


.rdrStartEdge {
    border-top-left-radius: 0px!important;
    border-bottom-left-radius: 0px!important;
    background-color: var(--primary-color);
    
}

.rdrStartEdge .rdrDayNumber span  {
    color: #FFF !important; 
}

.rdrStartEdge span.rdrDayNumber {
    position: relative;
}

.rdrStartEdge span.rdrDayNumber:before {
    content: "";
    position: absolute;
    background-color: #D9D9D9;
    height: 20px;
    width: 1.4rem;
    z-index: -1;
}

.rdrDayEndPreview {
    border-radius: 0px!important;
}

.rdrDayStartPreview {
}

.rdrDayStartPreview, .rdrDayInPreview, .rdrDayEndPreview {
    background: rgba(255, 255, 255, 0.09);
    position: absolute;
    top: 3px;
    left: 0px;
    right: 0px;
    bottom: 3px;
    pointer-events: none;
    border: 0px solid transparent; 
    z-index: 1;
}

.rdrNextPrevButton {
    border-radius: 0 !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: 28px;
    height: 28px;
    position: relative;
    line-height: 0;
}

.rdrNextPrevButton i {
    display: block;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.rdrNextPrevButton.rdrPprevButton {
    background-color: var(--nav-prev-bg, var(--primary-color));
}

.rdrNextPrevButton.rdrNextButton,
.rdrNextPrevButton.rdrPnextButton {
    background-color: var(--nav-next-bg, var(--primary-color));
}

.rdrNextPrevButton.rdrPprevButton i {
    border-right: 6px solid var(--nav-prev-icon, #ffffff) !important;
    border-left: 0;
    transform: translate(-50%, -50%);
}

.rdrNextPrevButton.rdrNextButton i,
.rdrNextPrevButton.rdrPnextButton i {
    border-left: 6px solid var(--nav-next-icon, #ffffff) !important;
    border-right: 0;
    transform: translate(-50%, -50%);
    margin: 0 !important;
}

&.hide-prev .rdrNextPrevButton.rdrPprevButton,
&.hide-prev .rdrPprevButton {
    background: #ededf3 !important;
    background-color: #ededf3 !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
}

&.hide-prev .rdrNextPrevButton.rdrPprevButton i,
&.hide-prev .rdrPprevButton i {
    border-right-color: #d7d7dd !important;
}

&.hide-next .rdrNextPrevButton.rdrNextButton,
&.hide-next .rdrNextPrevButton.rdrPnextButton,
&.hide-next .rdrPnextButton {
    background: #ededf3 !important;
    background-color: #ededf3 !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
}

&.hide-next .rdrNextPrevButton.rdrNextButton i,
&.hide-next .rdrNextPrevButton.rdrPnextButton i,
&.hide-next .rdrPnextButton i {
    border-left-color: #d7d7dd !important;
}
`
